export default __webpack_public_path__ + "static/media/Inter-UI-Medium.817ec446.woff2";